import Tool, {
  type ToolArgsWithController,
  type ToolArgs,
} from '../../../tools/Tool';
import { Editor } from 'slate';
import { isSharedSnippetElement } from '../../../types/guards';

class ToolEditSnippet extends Tool {
  static toolName = 'Edit snippet';
  static iconClass = 'far fa-pen-to-square';

  static action({ editor, controller }: ToolArgsWithController): void {
    const provider = controller.ahaEditor.getProvider('sharedSnippet');
    if (!provider) return;

    const sharedSnippet = Editor.above(editor, {
      match: isSharedSnippetElement,
    });
    if (!sharedSnippet) return;

    provider.onEditSharedSnippet(sharedSnippet[0].sharedSnippet_token);
  }

  static isEnabled({ editor }: ToolArgs): boolean {
    const sharedSnippet = Editor.above(editor, {
      match: isSharedSnippetElement,
    });
    if (!sharedSnippet) return false;

    return true;
  }
}

export default ToolEditSnippet;
